import { GridCell, GridRow } from '@pocketlaw/tetris';
import { useParams } from 'react-router-dom';
import { TeamMembersTable } from './TeamMembersTable';
import { TeamProfileCard } from './TeamProfileCard';
export function TeamProfilePage() {
    const { teamId } = useParams();
    return (<GridRow>
      <GridCell width={{ mobile: 12, desktop: 4 }}>
        <TeamProfileCard teamId={teamId}/>
      </GridCell>
      <GridCell width={{ mobile: 12, desktop: 8 }}>
        <TeamMembersTable teamId={teamId}/>
      </GridCell>
    </GridRow>);
}
